<div class="modal-header">
  <h5 class="modal-title">Email Required</h5>
</div>

<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="form-group">
      <label class="form-control-label">Email Address <span class="text-danger">*</span></label>
      <input 
        type="email" 
        class="form-control" 
        formControlName="email"
        placeholder="Enter email address"
        [ngClass]="{'is-invalid': isSubmitted && f.email.errors}">
      
      <div *ngIf="isSubmitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">Email is required</div>
        <div *ngIf="f.email.errors.pattern">Please enter a valid email address</div>
      </div>
    </div>
    
    <p class="text-muted small">
      Please provide your email address to proceed with saving the information.
    </p>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-primary">
      Proceed
    </button>
  </div>
</form>